<template>
  <kst-action v-if="row.DispatchID === Model.NewItem.DispatchID">
    <kst-action-item>
      <kst-button action-mode full-label
        :module="Model.Item.Module"
        :moduleType="Model.Item.ModuleType.New"
        :urlParams="urlParams"
      />
    </kst-action-item>
    <kst-action-item>
      <kst-button action-mode full-label
        :module="Model.Item.Module"
        :moduleType="Model.Item.ModuleType.Select"
        :urlParams="urlParams"
      />
    </kst-action-item>
  </kst-action>
</template>

<script>
import Model from "../PurchaseModel.js";

export default {
  props: {
    data: Object,
    row: Object
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.Name]: this.row.Name,
        [this.$kst.Enum.Param.PurchaseID]: this.data.ID,
        [this.$kst.Enum.Param.PurchaseItemID]: this.row.ID
      });
    }
  }
}
</script>